import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        At Price Bros Equipment, we value your privacy. This Privacy Policy
        explains how we collect, use, and protect your information when you use
        our website.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <p className="mb-4">
        We may collect personal information such as your name, email address,
        phone number, and company name when you fill out forms on our site.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <p className="mb-4">
        Your information may be used to respond to inquiries, process requests,
        improve our website, and send promotional emails (only if you opt in).
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        3. Sharing Information
      </h2>
      <p className="mb-4">
        We do not sell or share your personal information with third parties
        except as required by law or necessary to fulfill services you request.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Cookies</h2>
      <p className="mb-4">
        Our site may use cookies to enhance your browsing experience. You can
        choose to disable cookies in your browser settings.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Data Security</h2>
      <p className="mb-4">
        We implement reasonable measures to protect your personal information
        from unauthorized access, alteration, or disclosure.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Your Consent</h2>
      <p className="mb-4">
        By using our website, you consent to our privacy policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        7. Changes to This Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. Updates will be
        posted on this page with the revised effective date.
      </p>

      <p className="mt-8 text-sm text-gray-600">
        If you have any questions about this Privacy Policy, please contact us
        at{" "}
        <a
          href="mailto:parts@pricebroseq.com"
          className="text-blue-500 hover:underline"
        >
          parts@pricebroseq.com
        </a>
        .
      </p>
    </div>
  );
}
